import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'

import { useViewModeFromUrl } from 'partner360/hooks/useViewModeFromUrl'

import { invalidateFinancialCockpitData } from '../financialCockpitSlice'

export const useRefetchPlanningCockpitData = () => {
  const dispatch = useAppDispatch()
  const viewMode = useViewModeFromUrl()

  return useCallback(() => {
    if (viewMode === 'new') {
      dispatch(invalidateFinancialCockpitData())
    }
  }, [dispatch, viewMode])
}
